import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap CSS
import Container from "react-bootstrap/Container";
import Dashboard from "./components/Dashboard";
import Header from "./components/ui/Header";
import Footer from "./components/ui/Footer";
import ModelComparisonPage from "./components/ModelComparisonPage";
import DocumentAnalysisPage from "./components/DocumentAnalysisPage";
import AnalyticsDashboard from "./components/AnalyticsDashboard";
import EntityAnalysisPage from "./components/EntityAnalysisPage";
import "./App.css";

const App: React.FC = () => {
  return (
    <Router>
      <div className="app-container">
        <Header />
        <main className="main-content">
          <Container>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/redact" element={<Dashboard />} />
              <Route path="/comparison" element={<ModelComparisonPage />} />
              <Route path="/names" element={<EntityAnalysisPage />} />
              <Route path="/paragraphs" element={<DocumentAnalysisPage />} />
              <Route path="/analytics" element={<AnalyticsDashboard />} />
            </Routes>
          </Container>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
